<template>
  <!-- partial -->
  <div class="main-panel">
    <div class="content-wrapper">
      <div class=" cardplay" ref="pdfContent" id="contentToPrint">
        <div class="row">
          <div class="col-md-4 grid-margin d-flex justify-content-center align-items-center">
          </div>

          <div class="col-md-4 grid-margin d-flex justify-content-center align-items-center">
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex justify-content-center align-items-center">


                <h2 class=" d-flex justify-content-center align-items-center">Dashboard</h2>


              </div>
            </div>


          </div>
          <div class="col-md-4 grid-margin d-flex justify-content-lg-end justify-content-center align-items-center">
            <button @click="generatePDF" class="btn btn-dark" style="color: white;"> Descargar <i
                class="fa-solid fa-download"></i></button>
          </div>
        </div>

        <div class="row">
          <div class="col-md-3 col-12">
            <p>Sucursal</p>
            <select v-model="sucursal" class="form-select mb-3" aria-label="Default select example">
              <!-- <option selected>Sucursal</option> -->
              <!-- <option v-for="sucursal in this.userRoles"  :value="this.user">One</option> -->
              <!-- <option v-for="sucursal in userRoles" :value="sucursal">{{ sucursal }}</option> -->
              <option v-for="(sucursal, index) in this.sucursales" :key="index" :value="sucursal">{{ (sucursal == 'ALL') ? 'Mostrar Todos' : sucursal  }}
              </option>

            </select>
          </div>
          <div v-if="this.asesores.length > 0 && (this.Consultor || this.Admin || this.Coordinacion || this.modoThanos)"
            class="col-md-3 col-12">
            <p>Asesor</p>
            <select v-model="this.asesor" class="form-select mb-3" aria-label="Default select example">
              <!-- <option selected>Sucursal</option> -->
              <!-- <option v-for="sucursal in this.userRoles"  :value="this.user">One</option> -->
              <!-- <option v-for="sucursal in userRoles" :value="sucursal">{{ sucursal }}</option> -->
              <option value="Mostrar Todos">Mostrar Todos
              </option>
              <option v-for="(asesor, index) in this.asesores" :key="index" :value="asesor.id">{{ asesor.first_name }}
                {{ asesor.last_name }}
              </option>

            </select>
          </div>

          <div v-if="this.asesores.length > 0 && (this.Consultor || this.Admin || this.Coordinacion || this.modoThanos)"
            class="col-md-3 col-12">
            <p>Tipo Cartera</p>
            <div class="tipo-cartera-select mb-3">
              <button
                type="button"
                class="form-select tipo-cartera-trigger"
                @click="this.tipoCarteraDropdownOpen = !this.tipoCarteraDropdownOpen"
              >
                {{ this.tipoCarteraResumen }}
              </button>
              <div v-if="this.tipoCarteraDropdownOpen" class="tipo-cartera-menu">
                <label class="form-check tipo-cartera-option">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :checked="this.tipoCartera.length === 0"
                    @change="limpiarTipoCartera"
                  >
                  <span class="form-check-label">Mostrar Todos</span>
                </label>
                <label class="form-check tipo-cartera-option">
                  <input class="form-check-input" type="checkbox" :value="-1" v-model.number="this.tipoCartera">
                  <span class="form-check-label">AGRICOLA</span>
                </label>
                <label v-for="(tipo, index) in this.tiposCartera" :key="index" class="form-check tipo-cartera-option">
                  <input class="form-check-input" type="checkbox" :value="Number(tipo.id)" v-model.number="this.tipoCartera">
                  <span class="form-check-label">{{ tipo.nombre }}</span>
                </label>
              </div>
            </div>
          </div>
          <div v-if="this.asesores.length > 0 && (this.Consultor || this.Admin || this.Coordinacion || this.modoThanos)"
            class="col-md-3 col-12">
            <p>Otro Estado</p>
            <select v-model="this.estadoSeleccionado" class="form-select mb-3" aria-label="Default select example">
              <!-- <option selected>Sucursal</option> -->
              <!-- <option v-for="sucursal in this.userRoles"  :value="this.user">One</option> -->
              <!-- <option v-for="sucursal in userRoles" :value="sucursal">{{ sucursal }}</option> -->
              <option value="0">Mostrar Todos
              </option>
              <option value="Fallecido">Fallecido</option>
              <option value="Legal">Legal</option>
              <option value="Devuelto">Devuelto</option>

            </select>
          </div>
        </div>

        <!-- Content -->

        <div v-if="ready">
          <div class="row">
            <!-- <div class="col-md-12 grid-margin stretch-card"> -->
            <!-- <div :class="(this.sucursal=='ALL')?'col-md-12 grid-margin stretch-card':'col-md-3 grid-margin stretch-card'">
            <div class="card">
              <div class="card-body">
                <h4 class="grey text-md-center text-xl-left">Total Créditos:</h4>
                <div
                  class="d-flex flex-column flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                  <h4 class="text-center mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{{ this.dashboard.noCreditos }}
                  </h4>
                  <p class="mt-3 mb-0 mt-2 text-center"> <b>Saldo Capital:</b> {{
                    this.formatoNumero(this.dashboard?.saldoActivos + this.dashboard?.saldoVencidos+ this.dashboard?.saldoLegal) }} {{ this.moneda
                    }} </p>

                  <p class="mt-1 mb-0 text-success">100% </p>

                </div>
              </div>
            </div>
          </div> -->
            <div class="col-md-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="text-success text-md-center text-xl-left">Cartera Activa:</h4>
                  <div
                    class="d-flex flex-column flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                    <h4 class="text-center mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{{ this.dashboard.noActivos +
                      this.dashboard.noVencidos + this.dashboard.noLegal }} créditos
                    </h4>
                    <p class="mt-3 mb-0 mt-2 text-center"> <b>Saldo Capital:</b> {{
                      this.formatoNumero(this.dashboard?.saldoActivos + this.dashboard?.saldoVencidos +
                        this.dashboard?.saldoLegal) }} {{ this.moneda
                      }} </p>

                    <!-- <p class="mb-0 mt-2 text-success">{{
                    ((this.dashboard.noActivos * 100) / this.dashboard.noCreditos).toFixed(2) }}%</p> -->
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="col-md-3 grid-margin stretch-card">
            <div class="card">
              <div class="card-body">
                <h4 class="text-success text-md-center text-xl-left">Créditos Activos:</h4>
                <div
                  class="d-flex flex-column flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                  <h4 class="text-center mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{{ this.dashboard.noActivos }}
                  </h4>
                  <p class="mt-3 mb-0 mt-2 text-center"> <b>Saldo Capital:</b> {{
                    this.formatoNumero(this.dashboard?.saldoActivos) }} {{ this.moneda }} </p>

                  <p class="mb-0 mt-2 text-success">{{
                    ((this.dashboard.noActivos * 100) / this.dashboard.noCreditos).toFixed(2) }}%</p>
                </div>
              </div>
            </div>
          </div> -->
            <!-- <div class="col-md-3 grid-margin stretch-card">
            <div class="card">
              <div class="card-body">
                <h4 class="text-warning text-md-center text-xl-left">Créditos Vencidos:</h4>
                <div
                  class="d-flex flex-column flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                  <h4 class="text-center mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{{ this.dashboard.noVencidos }}
                  </h4>
                  <p class="mt-3 mb-0 mt-2 text-center"> <b>Saldo Capital:</b> {{ this.formatoNumero(
                    this.dashboard?.saldoVencidos) }} {{ this.moneda }} </p>

                  <p class="mb-0 mt-2 text-warning">{{
                    ((this.dashboard.noVencidos * 100) / this.dashboard.noCreditos).toFixed(2) }}%</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3 grid-margin stretch-card">
            <div class="card">
              <div class="card-body">
                <h4 class="text-primary text-md-center text-xl-left">Créditos Cancelados</h4>
                <div
                  class="d-flex flex-column flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                  <h4 class="text-center mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{{ this.dashboard.noCancelados }}
                  </h4>
                  <p class="mt-3 mb-0 mt-2 text-center"> <b>Saldo Capital:</b> {{ this.formatoNumero(
                    this.dashboard?.saldoCancelados) }} {{ this.moneda }} </p>

                  <p class="mb-0 mt-2 text-primary">{{
                    ((this.dashboard.noCancelados * 100) / this.dashboard.noCreditos).toFixed(2) }}%</p>
                </div>
              </div>
            </div>
          </div> -->
            <!-- <div v-if="this.sucursal=='ALL'" class="col-md-3 grid-margin stretch-card">
            <div class="card">
              <div class="card-body">
                <h4 class="text-primary text-md-center text-xl-left">Créditos Legales</h4>
                <div
                  class="d-flex flex-column flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                  <h4 class="text-center mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{{ this.dashboard.noLegal }}
                  </h4>
                  <p class="mt-3 mb-0 mt-2 text-center"> <b>Saldo Capital:</b> {{ this.formatoNumero(
                    this.dashboard?.saldoLegal) }} {{ this.moneda }} </p>

                  <p class="mb-0 mt-2 text-primary">{{
                    ((this.dashboard.noLegal * 100) / this.dashboard.noCreditos).toFixed(2) }}%</p>
                </div>
              </div>
            </div>
          </div> -->


          </div>



          <!-- ****************************************************************************************** -->
          <!-- Rangos de Mora -->

          <!-- {{this.formatoNumero(this.dashboard?.totalAprobado)}} -->

          <div class="row card-2 horizontal-scrollable">
            <div class="col-12">
              <h4 class="text-danger mb-2 text-center">Rangos de Mora</h4>

              <table class="table" id="my-data-table">
                <thead>
                  <tr>
                    <th scope="col">Rangos</th>
                    <th scope="col">No.Clientes</th>
                    <th scope="col">Saldo de Capital</th>
                    <!-- <th scope="col">Capital Atrasado</th> -->
                    <th scope="col">Saldo Interes corriente (A la fecha)</th>
                    <th scope="col">Saldo Intereres Moratorio(A la fecha)</th>
                    <th scope="col" class="table-secondary">Total Saldo Vencido a pagar(A la fecha)</th>
                    <th scope="col" class="table-secondary">Total Saldo a pagar para cancelación(A la fecha)</th>
                    <th scope="col">Porcentajes</th>
                  </tr>
                </thead>
                <tbody>
                  <tr @click="abrirDetalle('Al Día')" style="cursor:pointer" class="filaRangos">
                    <th scope="row">Al Día</th>
                    <td>{{ this.dashboard.noVigente }}</td>
                    <td>{{ this.formatoNumero(
                      this.dashboard?.saldoVigente) }} {{ this.moneda }} </td>
                    <!-- <td>{{ this.formatoNumero(
                      this.dashboard?.saldoAtrasadoVigente) }} {{ this.moneda }} </td> -->
                    <td>{{ this.formatoNumero(
                      this.dashboard?.saldoInteresVigente) }} {{ this.moneda }} </td>
                    <td>{{ this.formatoNumero(
                      this.dashboard?.saldoMoraVigente) }} {{ this.moneda }} </td>
                    <td class="table-light">{{ this.formatoNumero(
                      this.dashboard?.saldoMinimoVigente) }} {{ this.moneda }} </td>
                    <td class="table-light">{{ this.formatoNumero(
                      this.dashboard?.saldoVigente + this.dashboard?.saldoInteresVigente +
                      this.dashboard?.saldoMoraVigente
                    ) }} {{ this.moneda }} </td>
                    <td>{{ ((this.dashboard?.saldoVigente / this.totalSaldoRangos) * 100).toFixed(2) }} %</td>
                  </tr>
                  <tr @click="abrirDetalle('1-30')" style="cursor:pointer" class="filaRangos">
                    <th scope="row">1-30</th>
                    <td>{{ this.dashboard.no30Dias }}</td>
                    <td>{{ this.formatoNumero(
                      this.dashboard?.saldo30Dias) }} {{ this.moneda }} </td>
                      <!-- <td>{{ this.formatoNumero(
                      this.dashboard?.saldoAtrasado30Dias) }} {{ this.moneda }} </td> -->
                    <td>{{ this.formatoNumero(
                      this.dashboard?.saldoInteres30Dias) }} {{ this.moneda }} </td>
                    <td>{{ this.formatoNumero(
                      this.dashboard?.saldoMora30Dias) }} {{ this.moneda }} </td>
                    <td class="table-light">{{ this.formatoNumero(
                      this.dashboard?.saldoMinimo30Dias)
                    }} {{ this.moneda }} </td>
                    <td class="table-light">{{ this.formatoNumero(
                      this.dashboard?.saldo30Dias + this.dashboard.saldoInteres30Dias + this.dashboard?.saldoMora30Dias)
                    }} {{ this.moneda }} </td>
                    <td>{{ ((this.dashboard?.saldo30Dias / this.totalSaldoRangos) * 100).toFixed(2) }} %</td>

                  </tr>
                  <tr @click="abrirDetalle('31-60')" style="cursor:pointer" class="filaRangos">
                    <th scope="row">31-60</th>
                    <td>{{ this.dashboard.no60Dias }}</td>
                    <td>{{ this.formatoNumero(
                      this.dashboard?.saldo60Dias) }} {{ this.moneda }} </td>
                      <!-- <td>{{ this.formatoNumero(
                      this.dashboard?.saldoAtrasado60Dias) }} {{ this.moneda }} </td> -->
                    <td>{{ this.formatoNumero(
                      this.dashboard?.saldoInteres60Dias) }} {{ this.moneda }} </td>
                    <td>{{ this.formatoNumero(
                      this.dashboard?.saldoMora60Dias) }} {{ this.moneda }} </td>
                    <td class="table-light">{{ this.formatoNumero(
                      this.dashboard?.saldoMinimo60Dias)
                    }} {{ this.moneda }} </td>
                    <td class="table-light">{{ this.formatoNumero(
                      this.dashboard?.saldo60Dias + this.dashboard?.saldoInteres60Dias +
                      this.dashboard?.saldoMora60Dias)
                    }} {{ this.moneda }} </td>
                    <td>{{ ((this.dashboard?.saldo60Dias / this.totalSaldoRangos) * 100).toFixed(2) }} %</td>

                  </tr>
                  <tr @click="abrirDetalle('61-90')" style="cursor:pointer" class="filaRangos">
                    <th scope="row">61-90</th>
                    <td>{{ this.dashboard.no89Dias }}</td>
                    <td>{{ this.formatoNumero(
                      this.dashboard?.saldo89Dias) }} {{ this.moneda }} </td>
                      <!-- <td>{{ this.formatoNumero(
                      this.dashboard?.saldoAtrasado89Dias) }} {{ this.moneda }} </td> -->
                    <td>{{ this.formatoNumero(
                      this.dashboard?.saldoInteres89Dias) }} {{ this.moneda }} </td>
                    <td>{{ this.formatoNumero(
                      this.dashboard?.saldoMora89Dias) }} {{ this.moneda }} </td>
                    <td class="table-light">{{ this.formatoNumero(
                      this.dashboard?.saldoMinimo89Dias)
                    }} {{ this.moneda }} </td>
                    <td class="table-light">{{ this.formatoNumero(
                      this.dashboard?.saldo89Dias + this.dashboard?.saldoInteres89Dias +
                      this.dashboard?.saldoMora89Dias)
                    }} {{ this.moneda }} </td>

                    <td>{{ ((this.dashboard?.saldo89Dias / this.totalSaldoRangos) * 100).toFixed(2) }} %</td>

                  </tr>
                  <tr @click="abrirDetalle('91-120')" style="cursor:pointer" class="filaRangos">
                    <th scope="row">91-120</th>
                    <td>{{ this.dashboard.noMoraContable }}</td>
                    <td>{{ this.formatoNumero(
                      this.dashboard?.saldoMoraContable) }} {{ this.moneda }} </td>
                      <!-- <td>{{ this.formatoNumero(
                      this.dashboard?.saldoAtrasadoMoraContable) }} {{ this.moneda }} </td> -->
                    <td>{{ this.formatoNumero(
                      this.dashboard?.saldoInteresMoraContable) }} {{ this.moneda }} </td>
                    <td>{{ this.formatoNumero(
                      this.dashboard?.saldoMoraMoraContable) }} {{ this.moneda }} </td>
                    <td class="table-light">{{ this.formatoNumero(
                      this.dashboard?.saldoMinimoMoraContable)
                    }} {{ this.moneda }} </td>
                    <td class="table-light">{{ this.formatoNumero(
                      this.dashboard?.saldoMoraContable + this.dashboard?.saldoInteresMoraContable +
                      this.dashboard?.saldoMoraMoraContable)
                    }} {{ this.moneda }} </td>
                    <td>{{ ((this.dashboard?.saldoMoraContable / this.totalSaldoRangos) * 100).toFixed(2) }} %</td>

                  </tr>
                  <tr @click="abrirDetalle('121-150')" style="cursor:pointer" class="filaRangos">
                    <th scope="row">121-150</th>
                    <td>{{ this.dashboard.no150Dias }}</td>
                    <td>{{ this.formatoNumero(
                      this.dashboard?.saldo150Dias) }} {{ this.moneda }} </td>
                      <!-- <td>{{ this.formatoNumero(
                      this.dashboard?.saldoAtrasado150Dias) }} {{ this.moneda }} </td> -->
                    <td>{{ this.formatoNumero(
                      this.dashboard?.saldoInteres150Dias) }} {{ this.moneda }} </td>
                    <td>{{ this.formatoNumero(
                      this.dashboard?.saldoMora150Dias) }} {{ this.moneda }} </td>
                    <td class="table-light">{{ this.formatoNumero(
                      this.dashboard?.saldoMinimo150Dias)
                    }} {{ this.moneda }} </td>
                    <td class="table-light">{{ this.formatoNumero(
                      this.dashboard?.saldo150Dias + this.dashboard?.saldoInteres150Dias +
                      this.dashboard?.saldoMora150Dias)
                    }} {{ this.moneda }} </td>

                    <td>{{ ((this.dashboard?.saldo150Dias / this.totalSaldoRangos) * 100).toFixed(2) }} %</td>

                  </tr>
                  <tr @click="abrirDetalle('151-180')" style="cursor:pointer" class="filaRangos">
                    <th scope="row">151-180</th>
                    <td>{{ this.dashboard.no180Dias }}</td>
                    <td>{{ this.formatoNumero(
                      this.dashboard?.saldo180Dias) }} {{ this.moneda }} </td>
                      <!-- <td>{{ this.formatoNumero(
                      this.dashboard?.saldoAtrasado180Dias) }} {{ this.moneda }} </td> -->
                    <td>{{ this.formatoNumero(
                      this.dashboard?.saldoInteres180Dias) }} {{ this.moneda }} </td>
                    <td>{{ this.formatoNumero(
                      this.dashboard?.saldoMora180Dias) }} {{ this.moneda }} </td>
                    <td class="table-light">{{ this.formatoNumero(
                      this.dashboard?.saldoMinimo180Dias)
                    }} {{ this.moneda }} </td>
                    <td class="table-light">{{ this.formatoNumero(
                      this.dashboard?.saldo180Dias + this.dashboard?.saldoInteres180Dias +
                      this.dashboard?.saldoMora180Dias)
                    }} {{ this.moneda }} </td>

                    <td>{{ ((this.dashboard?.saldo180Dias / this.totalSaldoRangos) * 100).toFixed(2) }} %</td>

                  </tr>
                  <tr @click="abrirDetalle('181-Adelante')" style="cursor:pointer" class="filaRangos">
                    <th scope="row">181-Adelante</th>
                    <td>{{ this.dashboard.no181Dias }}</td>
                    <td>{{ this.formatoNumero(
                      this.dashboard?.saldo181Dias) }} {{ this.moneda }} </td>
                      <!-- <td>{{ this.formatoNumero(
                      this.dashboard?.saldoAtrasado181Dias) }} {{ this.moneda }} </td> -->
                    <td>{{ this.formatoNumero(
                      this.dashboard?.saldoInteres181Dias) }} {{ this.moneda }} </td>
                    <td>{{ this.formatoNumero(
                      this.dashboard?.saldoMora181Dias) }} {{ this.moneda }} </td>
                    <td class="table-light">{{ this.formatoNumero(
                      this.dashboard?.saldoMinimo181Dias)
                    }} {{ this.moneda }} </td>
                    <td class="table-light">{{ this.formatoNumero(
                      this.dashboard?.saldo181Dias + this.dashboard?.saldoInteres181Dias +
                      this.dashboard?.saldoMora181Dias)
                    }} {{ this.moneda }} </td>

                    <td>{{ ((this.dashboard?.saldo181Dias / this.totalSaldoRangos) * 100).toFixed(2) }} %</td>

                  </tr>
                  <tr class="table-danger">
                    <th scope="row">Total</th>

                    <th>{{ this.noClientesRangos }} </th>
                    <th>{{ this.formatoNumero(
                      this.totalSaldoRangos) }} {{ this.moneda }} </th>
                    <!-- <th>{{ this.formatoNumero(
                      this.totalSaldoAtrasadoRangos) }} {{ this.moneda }} </th> -->
                    <th>{{ this.formatoNumero(
                      this.dashboard?.saldoInteresVigente + this.dashboard?.saldoInteres30Dias +
                      this.dashboard?.saldoInteres60Dias + this.dashboard?.saldoInteres89Dias +
                      this.dashboard?.saldoInteresMoraContable + this.dashboard?.saldoInteres150Dias + this.dashboard?.saldoInteres180Dias + this.dashboard?.saldoInteres181Dias) }} {{ this.moneda }} </th>
                    <th>{{ this.formatoNumero(
                      this.dashboard?.saldoMoraVigente + this.dashboard?.saldoMora30Dias +
                      this.dashboard?.saldoMora60Dias
                      + this.dashboard?.saldoMora89Dias + this.dashboard?.saldoMoraMoraContable + this.dashboard?.saldoMora150Dias + this.dashboard?.saldoMora180Dias + this.dashboard?.saldoMora181Dias) }} {{ this.moneda }}
                    </th>
                    <th class="">{{ this.formatoNumero(this.totalSaldoVencidoPagar) }} {{ this.moneda }} </th>
                    <th class="">{{ this.formatoNumero(
                      (this.dashboard?.saldoVigente + this.dashboard?.saldoInteresVigente +
                        this.dashboard?.saldoMoraVigente) +
                      (this.dashboard?.saldo30Dias + this.dashboard.saldoInteres30Dias +
                        this.dashboard?.saldoMora30Dias) +
                      (this.dashboard?.saldo60Dias + this.dashboard?.saldoInteres60Dias +
                        this.dashboard?.saldoMora60Dias) +
                      (this.dashboard?.saldo89Dias + this.dashboard?.saldoInteres89Dias +
                        this.dashboard?.saldoMora89Dias) +
                      (this.dashboard?.saldoMoraContable +
                        this.dashboard?.saldoInteresMoraContable + this.dashboard?.saldoMoraMoraContable)+
                        (this.dashboard?.saldo150Dias + this.dashboard?.saldoInteres150Dias + this.dashboard?.saldoMora150Dias) +
                        (this.dashboard?.saldo180Dias + this.dashboard?.saldoInteres180Dias + this.dashboard?.saldoMora180Dias) +
                        (this.dashboard?.saldo181Dias + this.dashboard?.saldoInteres181Dias + this.dashboard?.saldoMora181Dias)
                    ) }} {{ this.moneda }} </th>
                    <th>100%</th>
                  </tr>
                </tbody>
              </table>
            </div>



            <div iv class="col-lg-12 col-12 mt-lg-4 mb-lg-4 mt-4 d-flex flex-column justify-content-center">
              <p class="text-center mt-3">{{ this.sucursal }}</p>
              <h4 class="mb-2 text-center text-warning">Mora en Porcentajes</h4>
              <div class="col-4">
              <button class="btn btn-primary " style="color: white;" @click="detallesMora()" > Detalles </button>
              </div>

              <table class="table">
                <thead>
                  <tr>
                    <!-- <th scope="col">Mora 1-30</th> -->
                    <th scope="col">Mora Financiera</th>
                    <th scope="col">Mora Contable</th>
                    <th scope="col">Mora Total</th>
                  </tr>
                </thead>
                <tbody v-if="this.estadoMora === 1">
                  <tr>
                    <!-- <td>{{ ((this.dashboard?.saldo30Dias / this.totalSaldoRangos) * 100).toFixed(2) }} %</td> -->

                    <!-- <th>{{ (
                      ((this.dashboard?.saldo30Dias + this.dashboard?.saldo60Dias + this.dashboard?.saldo89Dias + this.dashboard?.saldoMoraContable) /
                        this.totalSaldoRangos) * 100).toFixed(2) }} %</th> -->
                        <th>{{ (
                      (( this.dashboard?.saldo60Dias + this.dashboard?.saldo89Dias + this.dashboard?.saldoMoraContable) /
                        this.dashboard?.totalAprobado) * 100).toFixed(2) }} %</th>
                        <th>{{ (
                      ((this.dashboard?.saldo30Dias + this.dashboard?.saldo60Dias + this.dashboard?.saldo89Dias + this.dashboard?.saldoMoraContable) /
                        this.dashboard?.totalAprobado) * 100).toFixed(2) }} %</th>

                    <!-- <th>{{ (
                      ((this.dashboard?.saldoMoraContable) / this.totalSaldoRangos) * 100).toFixed(2) }} %</th> -->


                    <th>{{ ((((this.dashboard?.saldo30Dias + this.dashboard?.saldo60Dias + this.dashboard?.saldo89Dias)
                      /
                      this.totalSaldoRangos) * 100) + (((this.dashboard?.saldoMoraContable) / this.totalSaldoRangos) *
                        100
                      )).toFixed(2) }} %</th>
                  </tr>

                </tbody>
                <tbody v-if="this.estadoMora === 2">
                  <tr>
                    <!-- <th>
                      <MathFormula 
                      :formula=" `(\\frac{${this.formatoNumero(this.dashboard.saldo30Dias)}  ${this.moneda} }{${this.formatoNumero(this.totalSaldoRangos)}   ${this.moneda}})*100 ` " /> 
                    </th> -->
                    <th>
                      <MathFormula 
                      :formula=" `(\\frac{${this.formatoNumero( this.dashboard?.saldo60Dias + this.dashboard?.saldo89Dias + this.dashboard?.saldoMoraContable)}  ${this.moneda} }{${this.formatoNumero(this.dashboard?.totalAprobado)}   ${this.moneda}})*100 ` " /> 
                    </th>
                    <th>
                      <MathFormula 
                      :formula=" `(\\frac{${this.formatoNumero((this.dashboard?.saldo30Dias + this.dashboard?.saldo60Dias + this.dashboard?.saldo89Dias + this.dashboard?.saldoMoraContable))}  ${this.moneda} }{${this.formatoNumero(this.dashboard?.totalAprobado)}   ${this.moneda}})*100 ` " /> 
                    </th>
                    <th>
                      <MathFormula 
                      :formula=" `(\\frac{${this.formatoNumero( (this.dashboard?.saldo30Dias + this.dashboard?.saldo60Dias + this.dashboard?.saldo89Dias + this.dashboard?.saldoMoraContable))}  ${this.moneda} }{${this.formatoNumero(this.totalSaldoRangos)}   ${this.moneda}})*100 ` " /> 
                    </th>


                    <!-- <th>{{ ((((this.dashboard?.saldo30Dias + this.dashboard?.saldo60Dias + this.dashboard?.saldo89Dias)
                      /
                      this.totalSaldoRangos) * 100) + (((this.dashboard?.saldoMoraContable) / this.totalSaldoRangos) *
                        100
                      )).toFixed(2) }} %</th> -->
                  </tr>

                </tbody>
                <tbody v-if="this.estadoMora === 3">
                  <tr>
                    <!-- <td>
                      <MathFormula 
                      :formula=" ` = \\left( \\frac{\\text{Saldo Capital 1-30 días} }{\\text{Total Saldo Capital}} \\right) *100` " /> 
                    </td> -->
                    <td>
                      <MathFormula 
                      :formula=" ` = \\left( \\frac{\\text{Saldo Capital > 30 días} }{\\text{Cartera Total}} \\right) *100` " /> 
                    </td>
                    <td>
                      <MathFormula 
                      :formula=" ` = \\left( \\frac{\\text{Saldo Capital >= 1 día} }{\\text{Cartera Total}} \\right) *100` " /> 
                    </td>
                    <td>
                      <MathFormula 
                      :formula=" ` = \\left( \\frac{\\text{Saldo Capital >= 1 día} }{\\text{Total Saldo Capital}} \\right) *100` " /> 
                    </td>


                  </tr>

                </tbody>
              </table>
            </div>


          </div>

          <!-- ****************************************************************************************** -->
          <div class="row align-items-center">
          <div v-if="readyCambioMora" class="col-md-6 col-12 p-0">
            <AlertaCambioRango
            :creditos1="this.creditosCambioMora.alertaMora1Dia"
            :creditos31="this.creditosCambioMora.alertaMora31Dias"
            :creditos61="this.creditosCambioMora.alertaMora61Dias"
            :creditos90="this.creditosCambioMora.alertaMora90Dias"
            />
          </div>
          <div v-else>
            <div class="col-md-6 col-12 d-flex justify-content-center align-items-center">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-12 ">
          <div class="horizontal-scrollable ">
          <!-- Indicadores de Cartera 1 -->
          <div class="indicadores d-flex flex-column pt-5">
            <div class="row justify-content-lg-start justify-content-center align-items-center">
              <div class="col-4 col-lg-3">
                <button @click="detallesIndicadores()" class="btn btn-dark ms-lg-3 ms-0" style="color: white;">Detalles</button>
              </div>
              <div class="col-6 col-lg-4 mt-sm-0 mt-4" >
                <h4 class="text-center display-5 mb-4  ms-lg-5 ms-0 d-flex  align-items-center">Indicadores de Cartera</h4>
              </div>
            </div>

            <div v-if="!mostrarDetalles" class="colores-cantidades">
              <div class="bg-success">Óptimo </div>
              <div class="bg-warning">Moderado</div>
              <div class="bg-critico">Crítico</div>
              <div class="bg-danger">Alerta Máxima</div>
            </div>

            <div class="indicardor-calidad-cartera d-flex "
              :class="(!mostrarDetalles) ? 'justify-content-start ms-3' : 'justify-content-start'">
              <div class="indicadores-cartera" :class="indicadoresColores(this.calidadCartera)">
                <h4>Calidad de la Cartera: {{ Math.floor(this.calidadCartera) }} %</h4>
              </div>

              <div v-if="mostrarDetalles" class="d-flex justify-content-center align-item-center ms-2">
                <MathFormula :formula="formulaCalidadCartera" /> &nbsp;
                <MathFormula :formula="formulaCalidadCarteraVariables" />


              </div>
            </div>
            <div class="indicador-interes-vencido d-flex"
              :class="(!mostrarDetalles) ? 'justify-content-start ms-3' : 'justify-content-start'">
              <div class="indicadores-cartera mt-2" :class="indicadoresColores(this.InteresVencido)">
                <h4>Tasa de Interes Vencido: {{ Math.floor(this.InteresVencido) }} %</h4>
              </div>
              <div v-if="mostrarDetalles" class="d-flex justify-content-center align-item-center ms-2">
                <MathFormula :formula="formulaInteresVencido" /> &nbsp;
                <MathFormula :formula="formulaInteresVencidoVariables" />

              </div>

            </div>
            <div class="indicador-tasa-incumplimiento d-flex"
              :class="(!mostrarDetalles) ? 'justify-content-start ms-3' : 'justify-content-start'">
              <div class="indicadores-cartera mt-2" :class="indicadoresColores(this.Incumplimiento)">
                <h4>Tasa de Incumplimiento: {{ Math.floor(this.Incumplimiento) }} %</h4>
              </div>
              <div v-if="mostrarDetalles" class="d-flex justify-content-center align-item-center ms-2">
                <MathFormula :formula="formulaIncumplimiento" /> &nbsp;
                <MathFormula :formula="formulaIncumplimientoVariables" />

              </div>
            </div>


          </div>


          <!-- ****************************************************************************************** -->
          <!-- Indicadores de Cartera 2 -->
          <div class="indicadores indicadores-footer d-flex flex-column pb-5">
            <!-- <div class="colores-cantidades">
              <div class="bg-success">Óptimo </div>
              <div class="bg-warning">Moderado</div>
              <div class="bg-critico">Crítico</div>
              <div class="bg-danger">Alerta Máxima</div>
            </div> -->

            <div class="indicardor-calidad-cartera d-flex"
              :class="(!mostrarDetalles) ? 'justify-content-start ms-3' : 'justify-content-start'">
              <div class="indicadores-cartera" :class="indicadoresColoresReverse(this.rendimientoCartera)">
                <h4>Rendimiento de Cartera: {{ this.rendimientoCartera }} %</h4>
              </div>

              <div v-if="mostrarDetalles" class="d-flex justify-content-center align-item-center ms-2">
                <MathFormula :formula="formulaRendimientoCartera" /> &nbsp;
                <MathFormula :formula="formulaRendimientoCarterasVariables" />


              </div>
            </div>
            <div class="indicador-interes-vencido d-flex"
              :class="(!mostrarDetalles) ? 'justify-content-start ms-3' : 'justify-content-start'">
              <div class="indicadores-cartera mt-2" :class="indicadoresColoresReverse(this.rotacionCartera)">
                <h4>Rotación de Cartera: {{ this.rotacionCartera }} %</h4>
              </div>
              <div v-if="mostrarDetalles" class="d-flex justify-content-center align-item-center ms-2">
                <MathFormula :formula="formulaRotacionCartera" /> &nbsp;
                <MathFormula :formula="formulaRotacionCarterasVariables" />

              </div>

            </div>

            
                </div>
            </div>

            
         </div>
      </div>

      <!-- Consentracion de Riesgo -->

            <ConcentracionRiesgo class="mt-4 mb-4" :departamentos="departamentos" :productos="productos" :asesor="this.asesor"
              :departamentoXProducto="dashboard.departamentoXProducto"
              :totalSaldoProductos="dashboard.productosSaldoCapital" :open="open" />

          <!-- Tabla de Indicadores -->
          <div class="mt-5 mb-4 d-flex flex-column"
            v-if="(this.Consultor || this.Admin || this.Coordinacion || this.modoThanos)">

            <h4 class="display-4 text-center mt-3 mb-2">Indicadores por asesor</h4>

            <TablaIndicadores :asesores="this.asesores" />

            <!-- <h4 class="display-4">Recup</h4> -->

            <!-- RECUPERACION INDIVIDUAL EN EL AÑO -->
            <h4 class="display-4 text-center mt-5">Recuperación {{ new Date().getFullYear() }} </h4>

            <ResumenMensualChart :resumenMensual="this.resumenMensual"
              :asesor="this.asesores.find(item => item.id === this.asesor) || {}"/>

            <!-- RECUPERACION CONJUNTA DEL MES -->
            <h4 class="display-4 text-center mt-5">Recuperación Mes Actual por Encargado {{ new Date().getMonth() }} {{
              new Date().getFullYear() }} </h4>
            <ResumenPorEncargadoBarChart :resumenEncargados="this.resumenEncargados" />


            <div>
              
            <ComparacionTotalesTable
              :anio-inicio="2020"
              :anio-fin="2025"
              tipo-cartera=""
              estado="ACTIVO"
              producto=""
              :user-admin="0"
              @error="handleError"
              @loaded="handleLoaded"
            />
          </div>
          </div>

          
          <!-- *************************************************************** -->
          <!-- Es Localizable y Estado Proceso -->
          <div class="row mt-5 mb-5">
            <div class="col-12 col-lg-4  pe-5">
              <h3 class="display-4 mb-3 text-center text-lg-start">Es Localizable</h3>
              <div class="d-flex justify-content-evenly justify-content-lg-between">
                <strong>Localizables: </strong>
                <p>{{ this.dashboard.noLocalizables }} Créditos</p>

              </div>
              <div class="d-flex justify-content-evenly justify-content-lg-between mb-5">
                <strong>No Localizables: </strong>
                <p>{{ this.dashboard.noNoLocalizables }} Créditos</p>
              </div>
            </div>
            <div class="col-12 col-lg-8">

              <h3 class="display-4 text-center">Estado Proceso</h3>

              <div class="row estadoProceso text-center">
                <!-- <div class="col-1"></div> -->
                <div class="col-12 col-lg-3">
                  <strong>Extrajudicial</strong>
                  <p>{{ this.dashboard.estadoProceso?.noExtrajudicial }} Créditos</p>
                </div>
                <div class="col-12 col-lg-2">
                  <strong>Judicial/Legal</strong>
                  <p>{{ this.dashboard.estadoProceso?.noJudicial }} Créditos</p>
                </div>
                <div class="col-12 col-lg-2">
                  <strong>Castigo</strong>
                  <p>{{ this.dashboard.estadoProceso?.noCastigo }} Créditos</p>
                </div>
                <div class="col-12 col-lg-2">
                  <strong>Irregular</strong>
                  <p>{{ this.dashboard.estadoProceso?.noIrregular }} Créditos</p>
                </div>
                <div class="col-12 col-lg-3">
                  <strong>Normal</strong>
                  <p>{{ this.dashboard.estadoProceso?.noNormal }} Créditos</p>
                </div>
              </div>

            </div>
          </div>

          <!-- ******************************************************************* -->

          <MapClientes :key="`${sucursal}`" :sucursal="this.sucursal" />

          <!-- Por Producto -->
          <!-- <FinancialProductsChart v-if="this.ready === true" :chartData="this.chartData" /> -->

          <!-- Estadisticas -->

          <div class="container mt-5">
            <div class="row">
              <h4 class="text-center mb-4">Cantidad de Créditos por Género</h4>
              <div class="col-md-6 grid-margin stretch-card">
                <div class="card-edades">
                  <div class="card-body">
                    <h4 class="text-primary text-md-center text-xl-left">Masculino</h4>
                    <div
                      class="d-flex flex-column flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                      <h4 class="text-center mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{{ this.dashboard.noMasculino
                      }}
                        créditos
                      </h4>
                      <p class="mt-3 mb-0 mt-2 text-center"> <b>Saldo Capital:</b> {{
                        this.formatoNumero(this.dashboard?.saldoMasculino) }} {{ this.moneda }} </p>


                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 grid-margin stretch-card">
                <div class="card-edades">
                  <div class="card-body">
                    <h4 class=" text-md-center text-xl-left" style="color: #F66799;">Femenino:</h4>
                    <div
                      class="d-flex flex-column flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                      <h4 class="text-center mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{{ this.dashboard.noFemenino }}
                        créditos
                      </h4>
                      <p class="mt-3 mb-0 mt-2 text-center"> <b>Saldo Capital:</b> {{
                        this.formatoNumero(this.dashboard?.saldoFemenino) }} {{ this.moneda }} </p>

                    </div>
                  </div>
                </div>
              </div>
              <h4 class="text-center mb-4">Cantidad de Créditos por Edad</h4>
              <div class="col-md-4 grid-margin stretch-card">
                <div class="card-edades">
                  <div class="card-body">
                    <h4 class="text-primary text-md-center text-xl-left">Jovenes</h4>
                    <h5 class="text-primary text-md-center text-xl-left">0-24 años</h5>
                    <div
                      class="d-flex flex-column flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                      <h4 class="text-center mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{{ this.dashboard.noJovenes }}
                        créditos
                      </h4>
                      <p class="mt-3 mb-0 mt-2 text-center"> <b>Saldo Capital:</b> {{
                        this.formatoNumero(this.dashboard?.saldoJovenes) }} {{ this.moneda }} </p>


                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 grid-margin stretch-card">
                <div class="card-edades">
                  <div class="card-body">
                    <h4 class=" text-md-center text-xl-left" style="color: #FFA700;">Adulto:</h4>
                    <h5 class=" text-md-center text-xl-left" style="color: #FFA700;">25-64 años</h5>

                    <div
                      class="d-flex flex-column flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                      <h4 class="text-center mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{{ this.dashboard.noAdultos }}
                        créditos
                      </h4>
                      <p class="mt-3 mb-0 mt-2 text-center"> <b>Saldo Capital:</b> {{
                        this.formatoNumero(this.dashboard?.saldoAdultos) }} {{ this.moneda }} </p>

                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 grid-margin stretch-card">
                <div class="card-edades">
                  <div class="card-body">
                    <h4 class=" text-md-center text-xl-left" style="color: #008C2B;">Adulto Mayor:</h4>
                    <h5 class=" text-md-center text-xl-left" style="color: #008C2B;">Mayores a 65 años</h5>
                    <div
                      class="d-flex flex-column flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                      <h4 class="text-center mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{{
                        this.dashboard.noAdultosMayores }} créditos
                      </h4>
                      <p class="mt-3 mb-0 mt-2 text-center"> <b>Saldo Capital:</b> {{
                        this.formatoNumero(this.dashboard?.saldoAdultosMayores) }} {{ this.moneda }} </p>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div v-else>
          <div class="d-flex justify-content-center">
            <div class="spinner-border text-success" role="status" style="width: 3rem; height: 3rem;">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "../Footer-App.vue"
import Security from "../security";
import html2pdf from 'html2pdf.js'

// import FinancialProductsChart from './FinancialProductsChart.vue';

import { store } from "../store";
import MapClientes from "./Map-Clientes.vue";
import MathFormula from "../MathFormula.vue";
import ConcentracionRiesgo from "./ConcentracionRiesgo.vue";
import TablaIndicadores from "./TablaIndicadores.vue";
import ResumenMensualChart from "./ResumenMensualChart.vue";
import ResumenPorEncargadoBarChart from "./ResumenMensualBarChart.vue";
import AlertaCambioRango from "./AlertaCambioRango.vue";
import ComparacionTotalesTable from "./ComparacionTotalesTable.vue";

export default {
  name: 'DashboardApp',
  components: {
    Footer,
    // FinancialProductsChart,
    MapClientes,
    MathFormula,
    ConcentracionRiesgo,
    TablaIndicadores,
    ResumenMensualChart,
    ResumenPorEncargadoBarChart,
    AlertaCambioRango,
    ComparacionTotalesTable,

  },
  data() {
    return {
      componentKey: 0,
      reload: false,
      store,
      moneda: 'lps',
      ready: false,
      dashboard: {},
      sucursales: [],
      asesores: [],
      sucursal: '',
      asesor: 'Mostrar Todos',
      estadoSeleccionado: '0',
      productoNombre: [],
      productoResultado: [],
      resumenMensual: {},
      calidadCartera: 0,
      mostrarDetalles: false,
      open: false,
      saldoInicial: (112320640.5 + 2267699.49),
      noClientesRangos: 0,
      totalSaldoRangos: 0.0,
      totalSaldoAtrasadoRangos: 0.0,
      tiposCartera: [],
      resumenEncargados: [],
      // Creditos Cambio Mora
      creditosCambioMora: [],
      readyCambioMora: false,
      // Detalles Mora Porcentajes
      estadoMora: 1, // Comienza en 1


      // Roles
      roles: ['Coordinacion', 'Admin', 'Finanzas', 'Asesor', 'Cordinador Sucursal', 'Consultor'],
      Finanzas: false,
      Admin: false,
      Coordinacion: false,
      Asesor: false,
      coordinadorSucursal: false,
      modoThanos: false,
      Consultor: false,
      readyVerMas: false,
      userRoles: [],
      tipoCartera: [],
      tipoCarteraDropdownOpen: false,

      departamentos: [
        'Francisco Morazan', 'Copan', 'Atlantida', 'Cortes', 'Olancho', 'Lempira', 'Yoro', 'Colón', 'Intibucá',
        'Gracias a Dios', 'La Paz', 'Ocotepeque', 'Santa Bárbara', 'Valle', 'Choluteca', 'Comayagua', 'El Paraíso', 'Islas de la Bahía'
      ],

      productos: ['Agricola', 'Creditrabajo 2', 'Creafuturo', 'CREDI TRABAJO1',],

      valores: {
        "Atlantida": {
          "Creafuturo": "4%"
        },
        "Francisco Morazan": {
          "Creditrabajo 2": "3%"
        }
      },
      chartData: {
        labels: [],
        datasets: [{
          label: 'Cantidad de créditos por producto',
          backgroundColor: '#FFC477',
          // data: [999, 600, 170, 620]
          data: []

        }]
      }
    }
  },
  beforeMount() {
    {

      this.obtenerTipoCartera()

      this.userRoles = Security.getUserRoles();
      this.roles.forEach(element => {

        if (this.userRoles[0]?.some(role => role.includes(element)) === true) {
          this[element] = true;
        } else if (this.userRoles[0]?.some(role => role.includes('Coordinador Sucursal')) === true) {
          this.coordinadorSucursal = true;
        } else if (this.userRoles[0]?.some(role => role.includes('Modo Thanos')) === true) {
          this.modoThanos = true;
        }



      });

      this.sucursales = Security.getUserSucursal()[0];
      this.sucursal = this.sucursales[0]

      if (this.sucursales[0] === 'ALL') {
        let sucursales = ['FRANCISCO MORAZAN', 'EL PARAISO', 'ATLANTIDA', 'COPAN', 'LEMPIRA', 'OCOTEPEQUE', 'OLANCHO', 'SANTA BARBARA', 'COMAYAGUA AGRICOLA', 'OLANCHO AGRICOLA', 'ATLANTIDA AGRICOLA', 'CHOLUTECA AGRICOLA', 'COLON AGRICOLA', 'EL PARAISO AGRICOLA', 'FRANCISCO MORAZAN AGRICOLA', 'INTIBUCA AGRICOLA', 'LEMPIRA AGRICOLA', 'LEMPIRA/TOMALA', 'LEMPIRA/ERANDIQUE', 'YORO AGRICOLA']

        this.sucursales = this.sucursales.concat(sucursales)


      }
      // Asesor 
      fetch(process.env.VUE_APP_API_URL + "/admin/users/sucursal", Security.requestOptions({}))
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.$emit('error', response.message);

            console.error(response.message)
          } else {
            this.asesores = response.data.users
          }
        })
        .catch(error => {
          this.$emit('error', error)
        })


      this.obtenerPagosMensual(0)

    }

  },

  mounted() {

  },
  watch: {
    sucursal(sucursal) {
      this.ready = false

      if (this.Asesor) {
        this.asesor = this.store.user.id
      }
      this.obtenerDashboardData(sucursal, this.asesor, this.tipoCartera, this.estadoSeleccionado)


    },
    asesor(asesor) {


      this.obtenerDashboardData("ALL", asesor, this.tipoCartera, this.estadoSeleccionado)

      if (asesor === 'Mostrar Todos') {
        this.sucursal = 'ALL'
        this.sucursales = ['FRANCISCO MORAZAN', 'EL PARAISO', 'ATLANTIDA', 'COPAN', 'LEMPIRA', 'OCOTEPEQUE', 'OLANCHO', 'SANTA BARBARA', 'COMAYAGUA AGRICOLA', 'OLANCHO AGRICOLA', 'ATLANTIDA AGRICOLA', 'CHOLUTECA AGRICOLA', 'COLON AGRICOLA', 'EL PARAISO AGRICOLA', 'FRANCISCO MORAZAN AGRICOLA', 'INTIBUCA AGRICOLA', 'LEMPIRA AGRICOLA', 'LEMPIRA/TOMALA', 'LEMPIRA/ERANDIQUE', 'YORO AGRICOLA']
      } else {
        this.sucursales = ["ALL"]
        this.sucursal = 'ALL'
        this.sucursales = this.sucursales.concat(this.asesores.find(ase => ase.id == asesor)?.sucursal || [])
      }

      if (asesor === 'Mostrar Todos') {
        this.obtenerPagosMensual(0)
      } else {
        this.obtenerPagosMensual(asesor)
      }

    },
    tipoCartera: {
      deep: true,
      handler(tipoCartera) {
        this.ready = false
        this.obtenerDashboardData(this.sucursal, this.asesor, tipoCartera, this.estadoSeleccionado)
      }
    },
    estadoSeleccionado(estadoSeleccionado) {
      this.ready = false
      this.obtenerDashboardData(this.sucursal, this.asesor, this.tipoCartera, estadoSeleccionado)
    },
  },

  methods: {
    detallesMora() {
      // Cambia el valor en orden: 1 → 2 → 3 → 1 → ...
      if (this.estadoMora === 1) {
        this.estadoMora = 2
      } else if (this.estadoMora === 2) {
        this.estadoMora = 3
      } else {
        this.estadoMora = 1
      }
    },
    formatoNumero(numero) {
      return new Intl.NumberFormat("en-US").format(numero)
    },
    indicadoresColores(cantidad) {
      return (Math.floor(cantidad) > 20 ? 'bg-danger' : (Math.floor(cantidad) >= 10.1 && Math.floor(cantidad) < 20) ? 'bg-critico' : (Math.floor(cantidad) >= 5.1 && Math.floor(cantidad) <= 10) ? 'bg-warning' : Math.floor(cantidad) < 5 ? 'bg-success' : 'bg-success')
    },
    indicadoresColoresReverse(cantidad) {
      return (Math.floor(cantidad) > 20 ? 'bg-success' : (Math.floor(cantidad) >= 10.1 && Math.floor(cantidad) < 20) ? 'bg-warning' : (Math.floor(cantidad) >= 5.1 && Math.floor(cantidad) <= 10) ? 'bg-critico' : Math.floor(cantidad) < 5 ? 'bg-danger' : 'bg-danger')
    },
    detallesIndicadores() {
      this.mostrarDetalles = !this.mostrarDetalles
      this.componentKey++ // Cambia la clave del componente para forzar su recarga
    },
    limpiarTipoCartera() {
      this.tipoCartera = []
    },
    normalizarTiposCartera(tipoCartera) {
      if (Array.isArray(tipoCartera)) {
        return tipoCartera.map(tipo => parseInt(tipo, 10)).filter(tipo => !Number.isNaN(tipo) && tipo !== 0)
      }
      const tipo = parseInt(tipoCartera, 10)
      return !Number.isNaN(tipo) && tipo !== 0 ? [tipo] : []
    },
    tipoCarteraPrincipal(tipoCartera) {
      const tipos = this.normalizarTiposCartera(tipoCartera)
      return tipos.length > 0 ? tipos[0] : 0
    },
    
    
    obtenerDashboardData(sucursal, asesor, tipoCartera, estadoSeleccionado) {

      if (asesor === 'Mostrar Todos') {
        asesor = 0
      } else {
        asesor = parseInt(asesor)
      }
      const tipoCarteras = this.normalizarTiposCartera(tipoCartera)
      fetch(process.env.VUE_APP_API_URL + "/admin/credito/dashboard-data", Security.requestOptions({ sucursal: sucursal, asesor: asesor, tipoCartera: this.tipoCarteraPrincipal(tipoCarteras), tipoCarteras: tipoCarteras, estado: estadoSeleccionado }))
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.$emit('error', response.message);

            console.error(response.message)
          } else {

            this.dashboard = response.data.dashboardData,

              this.totalSaldoRangos = (this.dashboard.saldoVigente + this.dashboard.saldo30Dias + this.dashboard.saldo60Dias + this.dashboard.saldo89Dias + this.dashboard.saldoMoraContable + this.dashboard.saldo150Dias + this.dashboard.saldo180Dias + this.dashboard.saldo181Dias)
              this.totalSaldoAtrasadoRangos = (this.dashboard.saldoAtrasadoVigente + this.dashboard.saldoAtrasado30Dias + this.dashboard.saldoAtrasado60Dias + this.dashboard.saldoAtrasado89Dias + this.dashboard.saldoAtrasadoMoraContable)
            this.noClientesRangos = (this.dashboard.noVigente + this.dashboard.no30Dias + this.dashboard.no60Dias + this.dashboard.no89Dias + this.dashboard.noMoraContable + this.dashboard.no150Dias + this.dashboard.no180Dias + this.dashboard.no181Dias)


            this.calidadCartera = (this.dashboard.saldoMoraContable + this.dashboard.saldo89Dias + this.dashboard.saldo60Dias + this.dashboard.saldo150Dias + this.dashboard.saldo180Dias + this.dashboard.saldo181Dias ) / this.totalSaldoRangos * 100


            //Agregar Departamentos y productos a la grafica
            this.departamentos = this.dashboard.departamentos
            this.productos = this.dashboard.productos



            for (const key in this.dashboard.productos) {
              if (Object.prototype.hasOwnProperty.call(this.dashboard.productos, key)) {
                this.productoNombre.push(key)
                this.chartData.labels.push(key)
                this.chartData.datasets[0].data.push(this.dashboard.productos[key])
              }
            }
            this.ready = true;
            console.log('Dashboard data loaded successfully:', this.dashboard);

          }
        })
        .catch(error => {
          this.$emit('error', error)
        })


        this.obtenerCambiosMora(sucursal, asesor, tipoCarteras)
    },
    obtenerCambiosMora(sucursal, asesor, tipoCartera) {

      if (asesor === 'Mostrar Todos') {
        asesor = 0
      } else {
        asesor = parseInt(asesor)
      }
      const tipoCarteras = this.normalizarTiposCartera(tipoCartera)
      fetch(process.env.VUE_APP_API_URL + "/admin/credito/cambio-mora", Security.requestOptions({ sucursal: sucursal, asesor: asesor, tipoCartera: this.tipoCarteraPrincipal(tipoCarteras), tipoCarteras: tipoCarteras }))
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.$emit('error', response.message);

            console.error(response.message)
          } else {

            this.creditosCambioMora = response.data.creditosCambioMora,

            console.log('Creditos Cambio Mora:', this.creditosCambioMora);

            this.readyCambioMora = true;

          }
        })
        .catch(error => {
          this.$emit('error', error)
        })
    },

    obtenerTipoCartera() {

      fetch(process.env.VUE_APP_API_URL + "/admin/credito/tipo-cartera", Security.requestOptions({}))
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.$emit('error', response.message);

            console.error(response.message)
          } else {
            this.tiposCartera = (response.data.tipoCartera || []).map(tipo => ({
              ...tipo,
              id: Number(tipo.id),
            }))

          }
        })
        .catch(error => {
          this.$emit('error', error)
        })
    },
    obtenerPagosMensual(asesor) {

      fetch(process.env.VUE_APP_API_URL + "/admin/pagos/PagosResumenMensual", Security.requestOptions({ asesor: asesor }))
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.$emit('error', response.message);

            console.error(response.message)
          } else {
            this.resumenMensual = response.data.resumen_mensual
            this.resumenEncargados = Array.isArray(response.data.recuperacion_x_asesor)
              ? response.data.recuperacion_x_asesor
              : []
          }
        })
        .catch(error => {
          this.$emit('error', error)
        })
    },
    generatePDF() {
      const element = this.$refs.pdfContent;
      this.open = true;

      const today = new Date().toISOString().split('T')[0]; // formato: YYYY-MM-DD
      const opt = {
        margin: [10, 10, 10, 10],
        filename: `dashboard-reporte-${today}.pdf`,
        image: { type: 'jpeg', quality: 1 },
        html2canvas: {
          scale: 3,
          useCORS: true,
          scrollY: 0
        },
        jsPDF: {
          unit: 'mm',
          format: [330, 250],
          orientation: 'landscape'
        },
        pagebreak: {
          mode: ['avoid-all', 'css', 'legacy']
        }
      };
      html2pdf().set(opt).from(element).save();
    },
    abrirDetalle(rango) {
      // let creditos
      store.etiqueta = rango

      store.rango = rango
      // store.sucursalSeleccionada = "ALL"
      store.sucursalSeleccionada = this.sucursal
      store.asesorSeleccionado = parseInt(this.asesor)  
      const tipoCarteras = this.normalizarTiposCartera(this.tipoCartera)
      store.tipoCarteraSeleccionado = this.tipoCarteraPrincipal(tipoCarteras)
      store.tipoCarterasSeleccionadas = tipoCarteras
      store.estadoSeleccionado = this.estadoSeleccionado


      // this.$router.push({ name: 'TablaCreditosMora' })
      const routeData = this.$router.resolve({
      name: 'TablaCreditosMora',
      query: {
        sucursal: this.sucursal ?? '',
        asesor: this.asesor ?? '',
        // tipo de cartera string
        tipoCartera: this.tipoCarteraPrincipal(tipoCarteras),
        tipoCarteras: tipoCarteras.join(','),
        estado: this.estadoSeleccionado ?? '',
        rango: rango ?? '',
      } 
    })

    window.open(routeData.href, '_blank', 'noopener')

  }


  },
  computed: {
    tipoCarteraResumen() {
      const tipos = this.normalizarTiposCartera(this.tipoCartera)
      if (tipos.length === 0) {
        return 'Mostrar Todos'
      }

      const nombres = tipos.map(tipo => {
        if (tipo === -1) {
          return 'AGRICOLA'
        }
        const cartera = this.tiposCartera.find(item => Number(item.id) === tipo)
        return cartera?.nombre || `Tipo ${tipo}`
      })

      return nombres.join(', ')
    },
    totalSaldoVencidoPagar() {
      return [
        this.dashboard?.saldoMinimoVigente,
        this.dashboard?.saldoMinimo30Dias,
        this.dashboard?.saldoMinimo60Dias,
        this.dashboard?.saldoMinimo89Dias,
        this.dashboard?.saldoMinimoMoraContable,
        this.dashboard?.saldoMinimo150Dias,
        this.dashboard?.saldoMinimo180Dias,
        this.dashboard?.saldoMinimo181Dias,
      ].reduce((total, valor) => total + (Number(valor) || 0), 0)
    },
    // Calida de Cartera
    formulaCalidadCartera() {
      return `=(\\frac{${this.formatoNumero((this.dashboard.saldoMoraContable + this.dashboard.saldo89Dias + this.dashboard.saldo60Dias))}   ${this.moneda}}{ ${this.formatoNumero(this.totalSaldoRangos)} ${this.moneda} } )*100 `;
    },
    formulaCalidadCarteraVariables() {
      return ` = \\left( \\frac{\\text{Saldo Capital } \\geq \\text{ a 31 días}}{\\text{Total Saldo Capital}} \\right) *100`;
    },
    // Tasa de Interes Vencido
    formulaInteresVencido() {
      return `=(\\frac{${this.formatoNumero(this.dashboard.saldoInteresMas30Dias)}  ${this.moneda} }{${this.formatoNumero(this.dashboard.saldoTotalInteres)}   ${this.moneda}})*100 `;
    },
    formulaInteresVencidoVariables() {
      return ` = \\left( \\frac{\\text{Saldo Interes } \\geq \\text{ a 30 días}}{\\text{Total Saldo Interes}} \\right) *100`;
    },
    InteresVencido() {
      return ((this.dashboard.saldoInteresMas30Dias / this.dashboard.saldoTotalInteres) * 100).toFixed(2)
    },
    // Tasa de Incumplimiento
    formulaIncumplimiento() {
      return `=(\\frac{${this.formatoNumero(this.dashboard.noInteresMas30Dias)}  creditos }{${this.formatoNumero(this.noClientesRangos)}   creditos})*100 `;
    },
    formulaIncumplimientoVariables() {
      return ` = \\left( \\frac{\\text{No. de Créditos } \\geq \\text{ a 30 días}}{\\text{Total No. de Créditos}} \\right) *100`;
    },
    Incumplimiento() {
      return ((this.dashboard.noInteresMas30Dias / this.noClientesRangos) * 100).toFixed(2)
    },
    // Rendimiento de Cartera
    formulaRendimientoCartera() {
      return `=(\\frac{${this.formatoNumero(this.dashboard.interesPagosMesHoy)} }{ \\frac{ ${this.formatoNumero(this.saldoInicial)} + ${this.formatoNumero(this.totalSaldoRangos)}}{2}    })*100 `;
    },
    formulaRendimientoCarterasVariables() {
      return ` = \\left( \\frac{\\text{Intereses del Mes }}{(\\frac{saldo Inicial + Saldo Final}{2})} \\right) *100`;
    },
    rendimientoCartera() {
      return ((this.dashboard.interesPagosMesHoy / ((this.saldoInicial + this.totalSaldoRangos) / 2)) * 100).toFixed(2)
    },
    // Rotacion de Cartera
    formulaRotacionCartera() {
      return `=(\\frac{${this.formatoNumero(this.dashboard.montoPagosHoyMesHoy)}   }{ \\frac{ ${this.formatoNumero(this.saldoInicial)} + ${this.formatoNumero(this.totalSaldoRangos)}}{2}    })*100 `;
    },
    formulaRotacionCarterasVariables() {
      return ` = \\left( \\frac{\\text{Monto Recuperado del Mes }}{(\\frac{saldo Inicial + Saldo Final}{2})} \\right) *100`;
    },
    rotacionCartera() {
      return ((this.dashboard.montoPagosHoyMesHoy / ((this.saldoInicial + this.totalSaldoRangos) / 2)) * 100).toFixed(2)
    },

  }

}
</script>

<style scoped>
.cardplay {
  border-radius: 12px;
  /* border-left-color: #4285f4; */
  border-top: 5px solid #ff910088;
  border-left: 5px solid #4286f467;
  padding: 50px;
  background-color: #FFFFFF;
}
@media (max-width: 767px) {
  .cardplay {

    padding: 15px;

  }
}
.card {
  border-radius: 7px;
  /* border-top: 1px solid #c5c5c588; */
  /* border-left: 1px solid #bebebe; */
}

@media (max-width: 767px) {
  .card {
    padding: 18px;
    /* Elimina el padding para dispositivos móviles */
  }
}

.card-body {
  height: 100%;
}

iframe {
  width: 100%;
  /* height: 100%; */
  border: none;
  overflow: hidden;
}

img {
  width: 80%;
  /* height: 100%; */
  border: none;
  overflow: hidden;
  border-radius: 70px;
}

.filaRangos:hover {
  background: #e4e4e4;
}

.tipo-cartera-select {
  position: relative;
}

.tipo-cartera-trigger {
  min-height: 38px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 32px;
}

.tipo-cartera-menu {
  position: absolute;
  z-index: 20;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  max-height: 190px;
  overflow-y: auto;
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  padding: 10px 12px;
  background: #fff;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
}

.tipo-cartera-option {
  display: flex;
  align-items: center;
  min-height: 32px;
  margin-bottom: 4px;
  padding: 6px 8px 6px 28px;
  border-radius: 4px;
}

.tipo-cartera-option:hover {
  background: #f5f5f5;
}

.tipo-cartera-option .form-check-input {
  margin-left: -16px;
  margin-right: 10px;
}

.grey {
  color: grey;
}

tr,
th,
td,
th {
  font-size: 12px;
}

.card-2 {
  border-radius: 7px;
  border-top: 1px solid #c5c5c588;
  border-left: 1px solid #bebebe;
  padding-block: 30px;
}

.card-edades {
  display: flex;
  width: 95%;
  border-radius: 7px;
  /* border: 1px solid #acacac88; */
  /* border-left: 2px solid #bebebe; */
  padding-block: 30px;

  /* width: 100px; */
  transition: width 1s ease 0s;

  box-shadow: 5px 5px 12px rgba(0, 0, 0, 0.3);
}

.card-edades:hover {
  width: 100%;
}

.estadoProceso {
  background-color: #ebebeb;
  padding: 5px;
  padding-top: 15px;
  padding-bottom: 15px;
  border-radius: 15px;
}

@media (max-width: 767px) {
  .estadoProceso {
    margin: 10px;

    /* Elimina el padding para dispositivos móviles */
  }
}


.indicadores {
  padding: 4px;
  margin-top: 20px;
  background-color: #f8f8f8;
  border-radius: 5px;
  position: relative;
}

.indicadores-footer {
  margin-top: 0px;
  border-radius: 0px 0px 5px 5px;

}

.colores-cantidades {
  position: absolute;
  right: 5px;
  margin-top: 50px;

}

/* En pantallas pequeñas (ej. celulares) */
@media (max-width: 768px) {
  .colores-cantidades {
    position: static; /* O relative, según cómo quieras que se comporte */
    right: auto;
    margin-bottom: 15px;
    margin-top: 5px;
  }

  .content-wrapper{
    padding: 10px !important;
  }
}

.colores-footer {
  position: absolute;
  left: 10px;
  width: 120px;
  bottom: 10px;
}

.colores-cantidades div {
  color: white;
  border-radius: 3px;
  padding: 5px;
  margin-bottom: 4px;
  box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.2);
}


.indicadores-cartera {
  background-color: #ebebeb;
  padding: 10px;
  padding-top: 15px;
  color: white;
  padding-bottom: 15px;
  border-radius: 3px;
  width: 280px;
}

.bg-critico {
  background-color: #ff9100 !important;
  /* color: #000 !important; */
}
</style>
